import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Observable } from "rxjs";
import { takeUntil, finalize } from "rxjs/operators";
import { RequestCancellationService } from "./request-cancellation.service";
import { TokenDisable } from "./../auth/constants";


// dieser interceptor checkt ob ein request mehrfach ausgeführt wird und cancelled den dann.
// aber nur requests mit Auth Header. Darum muss er auch ganz am Ende der DI Kette eingefügt werden

@Injectable()
export class CancelRequestsInterceptor implements HttpInterceptor {

  constructor(private cancellationService: RequestCancellationService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // prüfen ob der token temporär deaktiviert ist
    const tokenDisabled = req.headers.has('Authorization') && req.headers.get('Authorization') === TokenDisable;

    if (tokenDisabled) {
      // original request ohne auth header
      return next.handle(req);
    }

    if (req.headers.has('Authorization')) {
      
      // Request-Cancellation für doppelte Anfragen
      const cancellationSubject = this.cancellationService.cancelAndRegisterGetRequest(
        req.method,
        req.urlWithParams,
        req.body
      );

      return next.handle(req).pipe(
        takeUntil(cancellationSubject),
        finalize(() => {
          this.cancellationService.removeRequest(
            req.method,
            req.urlWithParams,
            req.body
          );
        })
      );
    }
    return next.handle(req);
  }
}
